/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import FormEntitySummaryCard from './FormEntitySummaryCard';

const useStyles = makeStyles({
  wrapper: {
    margin: '-.75rem',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  card: {
    margin: '.75rem',
    maxWidth: '20rem',
  },
});

/**
 * Container component over the array items summary cards.
 */
export default function CardsContainer({
  formEntities = [],
  config,
  openDeleteDialog,
  openEditDialog,
  readOnly = false,
  id,
  className,
  schema,
  formContext,
}) {
  const classes = useStyles();

  return formEntities?.length ? (
    <div id={id} className={classes.wrapper}>
      <div className={clsx(className, classes.container)}>
        {formEntities.map((entity, index) => (
          <FormEntitySummaryCard
            key={index}
            id={`${id}_${index}${entity.role ? `_${entity.role?.toLowerCase()}` : ''}_summaryCard`}
            type="CARD"
            entity={{ ...entity, order: index + 1 }}
            config={config}
            openDeleteDialog={entity.applicantId ? null : openDeleteDialog}
            openEditDialog={entity.applicantId ? null : openEditDialog}
            readOnly={readOnly}
            className={classes.card}
            schema={schema}
            formContext={formContext}
          />
        ))}
      </div>
    </div>
  ) : null;
}
